let makeObject = {
  "1995": {
    Ford: ["Excursion", "F250", "F350"]
  },
  "1996": {
       Ford: ["Excursion", "F250", "F350"]
  },
  "1997": {
        Ford: ["Excursion", "F250", "F350"]
  },
  "1998": {
       Ford: ["Excursion", "F250", "F350"]
  },
  "1999": {
        Ford: ["Excursion", "F250", "F350"]
  },
  "2000": {
       Ford: ["Excursion", "F250", "F350"]
  },
  "2001": {
        Ford: ["Excursion", "F250", "F350"]
  },
  "2002": {
        Ford: ["Excursion", "F250", "F350"]
  },
  "2003": {
        Ford: ["Excursion", "F250", "F350"]
  }
};
